import { CommonModule } from "@angular/common";
import {
  Component,
  ElementRef,
  HostListener,
  Injectable,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { BehaviorSubject, Subject, Subscription, fromEvent } from "rxjs";
import { debounceTime, distinctUntilChanged, throttleTime } from 'rxjs/operators';
import { PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { UserService } from 'src/app/services/UserService';
import { ApiService } from "src/app/services/api.service";
import { GigsumoService } from 'src/app/services/gigsumoService';
import { jobModuleConfig } from 'src/app/services/jobModuleConfig';
import { SearchData } from "src/app/services/searchData";
import { UserModel, WorkExperience } from 'src/app/services/userModel';
import { UtilService } from "src/app/services/util.service";
import { TeamcardComponent } from '../../../components/cards/teamcard/teamcard.component';
import { FilterPipe } from '../../../pipe/SearchFilter/filter.pipe';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { UpgradeMessageComponent } from '../../../upgrade-message/upgrade-message.component';
import { MessageWidgetComponent } from '../../../widget/message-widget/message-widget.component';
import { NodataFoundComponent } from '../../../widget/nodata-found/nodata-found.component';
import { WidgetModule } from '../../../widget/widget.module';
import { CreateteamModelComponent } from "../../model/createteam-model/createteam-model.component";
import { WorkexperienceModalComponent } from '../../model/workexperience-modal/workexperience-modal.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Injectable({
  providedIn: 'root'
})
@Component({
  selector: "app-team",
  standalone: true,
  imports: [BsDropdownModule, CommonModule, FormsModule, InfiniteScrollModule,
CommonSkeletonComponent, TeamcardComponent, NodataFoundComponent, WorkexperienceModalComponent, UpgradeMessageComponent, WidgetModule, MessageWidgetComponent, FilterPipe,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: "./team.component.html",
  styleUrls: ["./team.component.scss"],
})
export class TeamComponent implements OnInit {
  @ViewChild('myButton') myButton: ElementRef;
  @ViewChild("landingside1") menuElement: ElementRef;
  page: string = 'landingpage';
  membershipType = localStorage.getItem('MemberShipType');
  landingsidesticky1: boolean = false;
  landingsidesticky2: boolean = false;
  elementPosition: any;
  teamSearch: string;
  commonVariables: any = {};
  bsModalRef: BsModalRef;
  teamdata: any = [];
  connectionlistuserdata: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  teamlistuserdata: any = [];
  status = "ALL";
  loadAPIcall: boolean = false
  searchSubject = new Subject<string>();
  search: any;
  showNoDatafound: boolean = false;
  allTeams = true;
  activeTeams = false;
  RequestsReceived = false
  deactiveteam=false;
  inactiveteam=false;
  showWorkExpereince: boolean = false;
  stopScroll : boolean = false;
  count: number = 0;
  prevAfterkey = null;
  noDatafound: Array<string>;
  searchKey
  subscriber: Subscription;
  popupvisible: boolean = false
  userType: any = localStorage.getItem('userType');
  userId: string = localStorage.getItem('userId');
  supportModal: any;

  constructor(
    private api: ApiService,
    private searchData: SearchData,
    private modalService: BsModalService,
    private util: UtilService,
    private userService: UserService,
    private gigsumoService: GigsumoService,
    private pricePlan: PricePlanService,
    private route: ActivatedRoute
  ) {
    const myButton = document.getElementById('myButton');
    if (myButton) {
      fromEvent(myButton, 'click')
        .pipe(
          throttleTime(1000) // 1 second throttle
        )
        .subscribe(() => {
          this.openModalWithComponent();
        });

    }

  }


  userDataModel: any = {};

  ngOnInit() {

    this.updateSupportModule();
    if(this.membershipType!="Free"&&this.membershipType!="Pro"){
      if (
        this.route.queryParams["_value"].routeFrom != "" &&
        this.route.queryParams["_value"].routeFrom != undefined &&
        this.route.queryParams["_value"].routeFrom != null
      ) {
        this.getallteams("PENDING");
        this.activeFilter = 'PENDING';
      } else {
         this.getallteams(this.status);
      }
    }

    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
    )
      .subscribe(
        res => {

          this.updateSearch();
        }
      )
  }

  isSearchDisabled(): boolean {
    return ['Free', 'Pro'].includes(this.membershipType) ||
           ['JOB_SEEKER'].includes(this.userType);
  }
  async getUserDetails(): Promise<Record<string, boolean | any>> {

    const profileData = await this.userService.userProfileDetails({ userId: this.userId, userType: this.userType });
    const { exeperienceList } = profileData;
    let hasCurrentOrganization: boolean = false;
    if (Array.isArray(exeperienceList) && exeperienceList.length > 0) {
      exeperienceList.forEach((element: WorkExperience) => {
        if (element.currentOrganization) {
          hasCurrentOrganization = true;
        }
      });
    }
    else hasCurrentOrganization = false;
    return { hasCurrentOrganization: hasCurrentOrganization, data: exeperienceList };

  }

  letterCaps(name: string): string {
    if (!name) {
      return '';
    }

    const capitalizedPhrase = name
      .split(' ')
      .map(word => word[0].toUpperCase() + word.slice(1))
      .join(' ');

    return capitalizedPhrase;
  }


  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  @HostListener("window:scroll")
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= 24) {
      this.landingsidesticky1 = true;
      this.landingsidesticky2 = true;
    } else {
      this.landingsidesticky1 = false;
      this.landingsidesticky2 = false;
    }
  }
  no_of_Team: number
  TeamCreateLimit: { length: number, memberType: boolean }
  selectedStatus: any;
  searchContent:string="";
  obj: any = {
    limit: 10,
    page:1,
    userId: localStorage.getItem('userId'),
    searchAfterKey: null,
    status:this.status,
    searchContent:this.searchContent
  }
  activeFilter:string='ALL';
  filterteam(filter){
    this.activeFilter = filter;
    this.obj.searchAfterKey=null;
    this.obj.searchContent="";
    this.searchContent = '';
    this.count=0
    this.stopScroll=false
    this.connectionlistuserdata.next([]);
    this.getallteams(filter);
  }
   updateSearch() {
    if (this.searchContent !== "" && this.searchContent.trim() === "") {
      // whitespace-only input: treat as a search with no results
      this.obj.searchContent = null;
      this.obj.searchAfterKey = null;
      this.count = 0;
      this.stopScroll = true;
      this.connectionlistuserdata.next([]);
      this.showNoDatafound = true;
      this.noDatafound = ['No data available!'];
      this.showButton = false;
      this.util.stopLoader();
      return;
    }
    this.obj.searchContent = this.searchContent.trim() !== "" ? this.searchContent.trim() : null;
    this.obj.searchAfterKey = null;
    this.count = 0;
    this.stopScroll = false;
    this.connectionlistuserdata.next([]);
    this.getallteams(this.status);
    this.util.stopLoader();
  }

  onScrollDown() {
    if(JSON.stringify(this.obj.searchAfterKey)!=JSON.stringify(this.prevAfterkey)){
      this.obj.searchAfterKey = (this.prevAfterkey && this.prevAfterkey.length === 0) ? null : this.prevAfterkey;
        this.getallteams(this.status);
    }
  }

  showButton:boolean=false
  getallteams(filter, status?: string) {
    this.loadAPIcall = true;
    let noData = [];
    this.obj.status = filter;
    this.status = filter;
    localStorage.setItem("acceptRejectBtn", "false");

    if (this.status === 'ACTIVE') {
      noData = this.searchContent !== "" ? ['No data available!'] : ['No data to display'];
      this.btnnameshow = 'Active Workspaces';
      this.showButton = false;
    } else if (this.status === 'DEACTIVATED') {

      noData = this.searchContent !== "" ? ['No data available!'] : ['No data to display'];
      this.btnnameshow = 'Deactive Workspaces';
      this.showButton = false;
    } else if (this.status === 'INACTIVE') {

      noData = this.searchContent !== "" ? ['No data available!'] : ['No data to display'];
      this.btnnameshow = 'Inactive Workspaces';
      this.showButton = false;
    } else if (this.status === 'PENDING') {
      localStorage.setItem("acceptRejectBtn", "true");
      noData = this.searchContent !== "" ? ['No data available!'] : ['No data to display'];
      this.btnnameshow = 'Requests Received';
      this.showButton = false;
    } else if (this.status === 'ALL' && !this.searchContent) {
      noData = [
        'b Please do one of the below, for Workspaces to be listed in the page',
        '1. Update your profile with your company business email ID.',
        '2. Complete your current work experience section in your profile.',
        '3. Connect with colleagues on the platform.',
        '4. Create a Workspace and add your colleagues to the Workspace.'
      ];
      this.btnnameshow = "All";
      this.showButton = true;
    } else if (this.searchContent !== "") {
      noData = ['No data available!'];
      this.showButton = false;
    }


    this.api.create("teams/findTeamsByStatus", this.obj).subscribe({
      next: (res) => {
        this.loadAPIcall = false;
         if (this.activeFilter !== filter) {
          return;
        }

        if (res.data.total === 0) {
          this.stopScroll = true;
        }

        if (res.data.teams != null) {
          const resData = res.data.teams;
          const afterKey = res.data.searchAfterKey;

          if (resData) {
            if (JSON.stringify(this.prevAfterkey) === JSON.stringify(afterKey) || resData.length === 0) {
              this.stopScroll = true;
            }
            this.prevAfterkey = afterKey;

            if (resData.length > 0) {
              const existingData = this.connectionlistuserdata.getValue();

              const dataMap = new Map();
              [...existingData, ...resData].forEach(item => {
                dataMap.set(item.teamId, item);
              });

              const uniqueData = Array.from(dataMap.values());
              this.connectionlistuserdata.next(uniqueData);
            }

            if (res.data.total !== undefined) {
              this.count = res.data.total;
            }
          }
        }

        this.showNoDatafound = this.connectionlistuserdata.getValue().length === 0;
        this.noDatafound = this.showNoDatafound ? noData : [];
      },
      error: (err) => {
        this.util.stopLoader();
      }
    });
  }


  teamLength: number = 0;


  sort_by_keyuserid(array, key) {
    return array.sort(function (a, b) {
      return parseInt(a.index) - parseInt(b.index);
    });

  }
  keyupdata(value : string) {
    this.searchSubject.next(value);
}


  filterByString(data, s) {
    return data.filter(e => e.teamName.toLowerCase().includes(s))
      .sort((a, b) => a.teamName.toLowerCase().includes(s) && !b.teamName.toLowerCase().includes(s) ? -1 : b.teamName.toLowerCase().includes(s) && !a.teamName.toLowerCase().includes(s) ? 1 : 0);
  }

  btnnameshow:string="All";
  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      if (sortOrder == -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    }
  }


  isCurrentOrganisation(userDataModel: UserModel): boolean {
    return Array.isArray(userDataModel.workExperience) && userDataModel.workExperience.some(respose => respose.currentOrganization === true);
  }
  async openModalWithComponent(workExpData?: any, val: "YES" | "NO" = "NO") {

    this.util.startLoader();
    if (!this.popupvisible) {
      this.popupvisible = true;
    }
    let response: any = await this.getUserDetails();
    this.userDataModel = response['data'];
    if (val === "NO") {
      if (!response['hasCurrentOrganization']) {
        this.showWorkExpereince = true;
        this.popupvisible = false;
        return;
      }
    }

    const userData = await this.pricePlan.UPDATE_USERDETAILS("TEAM_WORKSPACES");
    let { membershipType } = userData;
    if (userData.isExpired) {
      this.popupvisible = false;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
        if (ele.benefitKey == 'TEAM_WORKSPACES') {
          availablePoints = ele.available
          actualPoints = ele.actual
          utilizedPoints = ele.utilized
          promotional = ele.promotional
        }
      })
      let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

      if (['Starter','Growth','ScaleX'].includes(membershipType)) {
        popupType = "LIMIT";
      }
      this.pricePlan.expiredPopup("TEAM_WORKSPACES", popupType, null, null, null, null,availablePoints, actualPoints, utilizedPoints, promotional);

      return;
    }
    else {
      this.afterPLanValidation(workExpData, val);
    }
  }
  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };

  onSubmit(data: string) {
    if (data === GigsumoConstants.SUCESSCODE) {
      this.obj.searchAfterKey=null;
      this.searchContent="";
      this.prevAfterkey=null;
      this.stopScroll=false;
      this.connectionlistuserdata.next([]);
      this.count = Math.max(0, this.count - 1);
      this.getallteams(this.status);
    }
  }

  afterPLanValidation(workExpData?: any, val: "YES" | "NO" = "NO") {
    const initialState: any = {
      CurrentOrganizationData: val === "YES" ? workExpData : (this.userDataModel.length > 0 &&
        this.userDataModel.find(respose => respose.currentOrganization === true))
    };
    const modalOptions = { initialState, ...this.backdropConfig };
    this.showWorkExpereince = false;
    this.popupvisible = false;
    this.bsModalRef = this.modalService.show(CreateteamModelComponent, modalOptions);
    this.bsModalRef.content.closeBtnName = "Close";
  }

  showTeamIfWorkExpSucess(item: { content: "CLOSE" | "SUCESS", data: WorkExperience }) {

    if (item.content === "CLOSE") {
      this.showWorkExpereince = false;
      return;
    }

    if (item.data != null) {
      this.showWorkExpereince = false;
      this.userDataModel.workExperience = [item.data];
      // console.log("FINAL" , item.data);
      setTimeout(() => {
        this.openModalWithComponent(item.data, "YES");
      }, 1000);
    }
  }


  apicall() {
    let datas: any = {};
    datas.memberUserId = localStorage.getItem("userId");
    // datas.networkId =   networkId;
    this.api.create("teams/member/save", datas).subscribe((res) => {

    }, err => {
      this.util.stopLoader();

    });
  }

  messagemodelflag = false;
  messageData: any
  closeMessage() {
    this.messagemodelflag = false;
  }

  updateSupportModule() {

    let module = new jobModuleConfig(this.openSupport);
    module.source = this;
    this.supportModal = module;
  }

  openSupport() {
    // this.closeModal();
    let data: any = {}
    data.userId = localStorage.getItem('userId');
    data.groupType = "SUPPORT";
    let url = "findContactsByRefererId";
    this.api.messagePageService('POST', url, data).subscribe(res => {

      var userData: any = {};
      userData.groupId = null;
      if (res.length != 0) {
        userData.groupId = null;
        if (res[0].groupId) {
          userData.groupId = res[0].groupId;
        }
      }
      this.messageData = [];
      this.messagemodelflag = true;
      this.messageData.onlySupport = "SUPPORT";
      this.messageData.groupType = "SUPPORT";
      this.messageData.messageType = "SUPPORT";
      this.messageData.userId = localStorage.getItem('userId');
      this.messageData.id = userData.groupId;
    });
  }
}

